/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect } from 'react'
import { Modal } from 'antd-mobile'
// icon
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-02.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { observer } from 'mobx-react'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { GuideImgWrap, GuideWrap } from '@views/Popup/GuidePopup/index.style'
import StorageUtils from '@utils/storage-utils'

interface AutomaticSelectionGuidePopupProps {
  visible: boolean
  setVisible: (arg: boolean) => void
}

const AutoSelectionGuidePopup: React.FC<AutomaticSelectionGuidePopupProps>
  = (props: AutomaticSelectionGuidePopupProps) => {
  const { visible, setVisible } = props

  useEffect(() => {
    if (visible) {
      StorageUtils.saveGodBlessItemAutoSelectionGuidePopupShowedAt()
    }
  }, [visible])

  const onCloseModal = async () => {
    setVisible(false)
  }

  return (
    <Modal
      transparent
      visible={visible}
      maskClosable={false}
      onClose={onCloseModal}
      className="adv-new-dialog box-type big-size character-popup"
      wrapClassName="guide-notice-popup"
      css={AdvDialogStyle}
    >
      {/* 캐릭터 영역 */}
      <GuideImgWrap margin="0 0 22px" fontSize={14}>
        <div className="guide-circle">
          <img src={GuideCharacter} alt="캐릭터" className="guide-character"/>
        </div>
        <p className="guide-txt">
          신의 가호 자동 선택
        </p>
      </GuideImgWrap>

      <GuideWrap color="#506070" fontWeight="500" padding="24px 0">
        <div className="guide-box">
          선택한 신의 가호를 모두 사용하면<br/>
          보유한 신의 가호 중<br/>
          <span className="point-color--green">가장 높은 배당의 신의 가호</span>로 자동 선택됩니다.
        </div>
      </GuideWrap>

      <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
        <Button secondary onClick={onCloseModal} className="single-btn">
          확인
        </Button>
      </AdvDialogBtnWrap>

      <ModalBg onClick={onCloseModal}/>
    </Modal>
  )
}

export default observer(AutoSelectionGuidePopup)
